<script>
    import TrendRecommendation from "./TrendRecommendation.svelte";
    import LazyLoad from "vanilla-lazyload";
    import { onMount, setContext } from "svelte";
    import { calculateTileDimension } from "../utils/tileDimensionCalculator.js";
    import { key as cinemaTileDimensionCtxKey } from "../context/cinemaTileDimension.js";
    import scrollTracker from "../tracking/scrollTracker.js";
    import viewTracker from "../tracking/viewTracker.js";
    import { emitMiniActionEvent } from "../tracking/eventEmitter.js";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        headline,
        recommendations = [],
        performance,
        cinemaInjectionContainerWidth = 1000,
        tracking,
        featureIndex,
        additionalClickTracking,
        cinemaIndex,
        cinemaMeta,
        sourceVariationId = undefined,
        additionalTrackingLabels = null,
        transparentBackground = false,
        featuresState = {},
    } = $props();

    const { width, height, numberOfVisibleTiles } = calculateTileDimension(cinemaInjectionContainerWidth);
    const site = "reco_trend";

    setContext(cinemaTileDimensionCtxKey, {
        width,
        height,
    });

    const lazyLoadConfig = {
        unobserve_entered: true,
        threshold: 0,
        callback_loaded: (el) => {
            el.parentElement.nextElementSibling.firstElementChild.classList.remove("p_loader250");
        },
        callback_error: (el) => {
            el.parentElement.nextElementSibling.firstElementChild.classList.remove("p_loader250");
        },
    };

    let trendCinemaFeature;
    let visibilityPreviousActionAlreadyTracked = false;

    const trackView = (recommendations, numberOfVisibleTiles) => {
        const recommendationsTracking = recommendations
            .slice(0, numberOfVisibleTiles + 1)
            .map((recommendation) => recommendation.tracking);

        viewTracker(tracking, recommendationsTracking, featureIndex, cinemaIndex, null, additionalTrackingLabels, null);
    };

    const trackVisibilityVerticalScroll = (recommendations, numberOfVisibleTiles) => {
        const { id: cinemaFeatureId } = tracking;
        const tilesFeatureIds = recommendations
            .slice(0, numberOfVisibleTiles + 1)
            .map((recommendation) => recommendation.tracking.id);
        const featureIds = [cinemaFeatureId, ...tilesFeatureIds];
        emitMiniActionEvent(featureIds);
    };

    const trackVisibilityHorizontalScroll = (direction, tilesFeatureIds = []) => {
        const visibleRecos = recommendations.filter((reco) => tilesFeatureIds.includes(reco.tracking?.id));
        const recommendationsTracking = visibleRecos.map(({ tracking }) => tracking);
        const recommendationsMeta = visibleRecos.map(({ meta }) => meta);
        scrollTracker(
            tracking,
            recommendationsTracking,
            featureIndex,
            cinemaIndex,
            direction,
            cinemaMeta,
            recommendationsMeta,
            sourceVariationId,
            additionalTrackingLabels
        );
    };

    const lazyLoadImages = () => {
        if ("loading" in HTMLImageElement.prototype) {
            const images = document.querySelectorAll(".reco_trend_cinema__image .lazy");
            images.forEach((img) => {
                img.parentElement.nextElementSibling.firstElementChild.classList.remove("p_loader250");
                img.src = img.dataset.src;
            });
        } else {
            const images = document.querySelectorAll(".reco_trend_cinema__image .lazy");
            const lazyLoader = new LazyLoad(lazyLoadConfig, images);
            lazyLoader.update();
        }
    };

    onMount(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    trackVisibilityVerticalScroll(recommendations, numberOfVisibleTiles);
                    observer.unobserve(entry.target);
                }
            });
        });
        observer.observe(trendCinemaFeature);
        lazyLoadImages();
        const cinema = document.querySelector("oc-cinema-v1");

        performance.cinemaLoaded(site);

        trackView(recommendations, numberOfVisibleTiles);

        cinema.addEventListener("oc-stage-scroll-completed", (event) => {
            const tilesFeatureIds = event.detail.visibleItems.indices.map(
                (index) => recommendations[index]?.tracking?.id
            );
            const direction = event.detail.scrollDirection === "right" ? "next" : "previous";
            if (direction === "previous") {
                if (!visibilityPreviousActionAlreadyTracked) {
                    trackVisibilityHorizontalScroll(direction);
                    visibilityPreviousActionAlreadyTracked = true;
                }
            } else {
                trackVisibilityHorizontalScroll(direction, tilesFeatureIds);
            }
        });
    });
</script>

<div
    bind:this={trendCinemaFeature}
    class="{transparentBackground ? 'reco_trend_cinema_no_background' : 'reco_trend_cinema'} {site}"
>
    <h2 class="reco_trend_cinema__headline oc-headline-100 oc-headline-200--l">{headline}</h2>
    <oc-cinema-v1 items-per-page={numberOfVisibleTiles} gap="8px" class="reco_trend_cinema__carousel oc-ml-50">
        {#each recommendations as recommendation, index}
            <oc-placeholder-v1 interactive="true">
                <TrendRecommendation
                    {recommendation}
                    {featureIndex}
                    {cinemaIndex}
                    {cinemaMeta}
                    cinemaTracking={tracking}
                    additionalCinemaClickTracking={additionalClickTracking}
                    {additionalTrackingLabels}
                    {featuresState}
                    lazyLoad={index > 4}
                />
            </oc-placeholder-v1>
        {/each}
    </oc-cinema-v1>
</div>

<style lang="scss">
    .reco_trend_cinema {
        height: 100%;
        width: 100%;
        background-color: var(--oc-base-color-corporate-color-spectrum-positive-green-50);
        line-height: normal;
        padding: 16px 0 24px;
    }

    .reco_trend_cinema_no_background {
        height: 100%;
        width: 100%;
        line-height: normal;
        padding: 16px 0 24px;
    }

    .reco_trend_cinema__headline {
        padding-bottom: 16px;
        margin-left: 16px;
    }
</style>
